import { render, staticRenderFns } from "./BtnEnter.vue?vue&type=template&id=6afb5aca&"
import script from "./BtnEnter.vue?vue&type=script&lang=js&"
export * from "./BtnEnter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports